import request from '../utils/request.util'

export default {
  getGeneral () {
    return request.get('/dashboard/get-general')
  },
  getTotal (value) {
    return request.get(`/dashboard/total/${value}`)
  },
  getTop (value, params) {
    return request.get(`/dashboard/top/${value}`, { params })
  },
  getChart (params) {
    return request.get(`/dashboard/energy-bar-chart/`, { params })
  },
}
